<template>
  <div>contact</div>
</template>

<script>
export default {
  name: "ContactView"
}
</script>

<style scoped>

</style>
